package com.arenaproplay.admin.utils

import kotlinx.browser.localStorage
import org.w3c.dom.get
import org.w3c.dom.set

object Storage {
    private const val KEY_PREFIX = ""

    fun save(key: String, value: String) {
        try {
            localStorage["${KEY_PREFIX}$key"] = value
        } catch (e: Exception) {

            console.error("Failed to save to localStorage: $key", e)
        }
    }

    fun get(key: String): String? {
        return try {
            localStorage["${KEY_PREFIX}$key"]
        } catch (e: Exception) {
            console.error("Failed to read from localStorage: $key", e)
            null
        }
    }

    fun saveBoolean(key: String, value: Boolean) {
        save(key, value.toString())
    }

    fun getBoolean(key: String, defaultValue: Boolean = false): Boolean {
        return get(key)?.toBoolean() ?: defaultValue
    }

    fun saveInt(key: String, value: Int) {
        save(key, value.toString())
    }

    fun getInt(key: String, defaultValue: Int = 0): Int {
        return get(key)?.toIntOrNull() ?: defaultValue
    }

    fun remove(key: String) {
        try {
            localStorage.removeItem("${KEY_PREFIX}$key")
        } catch (e: Exception) {
            console.error("Failed to remove from localStorage: $key", e)
        }
    }

    fun clear() {
        try {
            val keysToRemove = mutableListOf<String>()
            for (i in 0 until localStorage.length) {
                val key = localStorage.key(i)
                if (key != null && key.startsWith(KEY_PREFIX)) {
                    keysToRemove.add(key)
                }
            }
            keysToRemove.forEach { localStorage.removeItem(it) }
        } catch (e: Exception) {
            console.error("Failed to clear localStorage", e)
        }
    }

    fun contains(key: String): Boolean {
        return get(key) != null
    }
}

object StorageKeys {
    const val LANGUAGE = "language"
    const val THEME = "theme"
    const val ACCESS_TOKEN = "auth.access_token"
    const val REFRESH_TOKEN = "auth.refresh_token"
    const val CURRENT_USER = "auth.current_user"
    const val SIDEBAR_COLLAPSED = "ui.sidebar_collapsed"
}
